import React from 'react';

import useDetectKeyboard from '../../hooks/useDetectKeyboard';
import { isIOS } from '../../utils/native/platform';

const KeyboardPadding: React.FC = () => {
    const { keyboardHeight } = useDetectKeyboard();
    return <div style={{ height: isIOS() ? keyboardHeight : 0 }} />;
};

export default KeyboardPadding;
